import { Component, OnInit, ViewChild, Output, EventEmitter, Input, ElementRef } from '@angular/core';
import { CdkDragDrop, moveItemInArray, CdkDrag } from '@angular/cdk/drag-drop';
import { FormGroup, FormControl, FormBuilder, FormArray, Validators, NgForm, Form } from '@angular/forms';
//import {MatSort,Sort} from '@angular/material/sort';
import { NgbModal, NgbModalConfig, ModalDismissReasons } from '@ng-bootstrap/ng-bootstrap';
import { Router, NavigationStart, ActivatedRoute } from "@angular/router";
import { AssessmentService } from "../../services/assessment.service";
import { NgxSpinnerService } from "ngx-spinner";
import { CapsuleValidator } from '../../services/capsule.validator';
interface objectEmit {
  assessment_id: any,
  status: boolean
}
@Component({
  selector: 'app-add-authoring-assessment',
  templateUrl: './add-authoring-assessment.component.html',
  styleUrls: ['./add-authoring-assessment.component.scss']
})
export class AddAuthoringAssessmentComponent implements OnInit {

  @Output() finalSubmit: any = new EventEmitter();
  @Input() assData: any;

  labelPosition: 2 | 1 = 1;
  disabled = false; createAssessmentForm: any; submitted = false; minError: any = '1'; page: string = ''; UploadFileData: any = null;
  uploadImgesurl: any = ''; uploadImgeName: any = []; Imgesurl: any = []; assessmentFormData: any = []; questionsData: any = [];
  question_asset_type_id: any = ''; mins: any = '00'; tempStoreAssessFormData: any = null; assessmentId: any = ''; closeResult: any = '';
  succesCalAssessment: boolean = false; activeCanMod: boolean = true; activeResteMod: boolean = true; modelsData: string = '';
  modelName: string = ''; returnObj: objectEmit = { assessment_id: null, status: false }; counterData: any = [];
  errorMsgImgSize: any = '';
  questionTypes_Obj:  any = { MCQ: '1', TF: '2', MTF: '3' };
  counterMinuites: any = []; butDisabled: boolean = true; internalValidateError: any = 0; externalValidateError: any = 0; adminData: any;
  internalError: any = 0; ExternalError: any = 0;
  showTextbox1: boolean=false;
  showTextbox2: boolean=false;
  addArray:any=[];
  constructor(private modalService: NgbModal, private config: NgbModalConfig, private auth: AssessmentService, private router: Router,
    private fb: FormBuilder, private spinner: NgxSpinnerService, private el: ElementRef) {
    /****form create assessment form validation */
  }
  /**********passign criteria validation */
  internalValidate() {
    this.internalValidateError = 0;
    if (this.createAssessmentForm.value.internal_org_pass_no_of_questions == 0) {
      this.internalValidateError = 1;
    }
  };
  externalValidate() {
    this.externalValidateError = 0;
    if (this.createAssessmentForm.value.external_org_pass_no_of_questions == 0) {
      this.externalValidateError = 1;
    }
  };
  onHrChange(e: any) {
    if (this.createAssessmentForm.value.assest_time_hr == '00' && this.createAssessmentForm.value.assest_time_min == '00') {
      //this.createAssessmentForm.controls['assest_time_min'].reset()
      this.minError = '2';
    } else if (this.createAssessmentForm.value.assest_time_hr == '00' && this.createAssessmentForm.value.assest_time_min == '') {
      this.minError = '2';
    } else {
      this.minError = '1';
    }
  }
  onMinChange(e: any) {
    if (this.createAssessmentForm.value.assest_time_min == '00' && this.createAssessmentForm.value.assest_time_hr == '00') {
      //this.createAssessmentForm.controls['assest_time_min'].reset()
      this.minError = '2';
    } else {
      this.minError = '1';
    }
  }
  get f() { return this.createAssessmentForm.controls; }
  loadCounter(j: number) {
    let variable = [];
    let i = 0;
    while (i <= j) {
      let pushData: any;
      if (i <= 9) {
        pushData = { label: '0' + i, value: '0' + i }
      } else {
        pushData = { label: '' + i, value: '' + i }
      }
      variable.push(pushData);
      i++;
    }
    return variable;
  }
  /********Add another function for store name and URL */
  get questionsGetter(): FormArray {
    return this.createAssessmentForm.get('questions') as FormArray;
  }
  /***add new question **/
  addNewRow(): void {
    let ObjDta = Object.assign({}, {questionTypes: this.questionTypes_Obj.MCQ});
    this.questionsGetter.push(this.initItemMore(ObjDta));
  }
  /********Add another delete row function for store name and URL */
  deleteRow(index: number) {
    this.questionsGetter.removeAt(index);
  }
  /********delete img file ******* */
  deleteImgRow(index: number) {
    (<FormGroup>(this.questionsGetter).controls[index]).get('question_asset_url')?.setValue('');
    (<FormArray>(this.questionsGetter).controls[index]).get('question_asset_type')?.setValue('');
  }
  deleteOptionRow(index:number,optionIndexs:number){
    this.createAssessmentForm.get('questions').controls[index].get('responses').removeAt(optionIndexs);
  }

  initItemMore(qTy: { questionTypes:any; }): FormGroup {
    let questionType = qTy.questionTypes;
    let ObjDta = Object.assign({}, {questionTypes: questionType});
    let dataObj=  Object.assign({}, {
      question_type: [questionType],
      question_text: [null, [Validators.required]],
      question_asset_url: [''],
      question_asset_type: [''],
      assessment_question_id: [null],
      assessment_id: [null],
      correct_response_no : [null, [Validators.required]],
      responses: this.fb.array([this.initItemRes(ObjDta), this.initItemRes(ObjDta)])
    });
    let formGrop= this.fb.group(dataObj);
    if (questionType == 3) {
      formGrop.get('correct_response_no')?.clearValidators();
      formGrop.get('correct_response_no')?.setValidators(null);
      formGrop.get('correct_response_no')?.updateValueAndValidity();
    }
    return formGrop;

  }

  private optionIndex:number=-1;
  get adds(): FormArray {
   return (<FormArray>(this.createAssessmentForm.get('questions')).controls[this.optionIndex]).get('responses') as FormArray;
  }
  addNewOptions(modal: {index:number; question_type: any}): void {
    this.optionIndex = modal.index;
    this.adds.push(this.initItemRes({questionTypes: modal.question_type}));
  }
  initItemRes(qTy: { questionTypes:any; }): FormGroup {
    let questionType = qTy.questionTypes;
    if(questionType == '3'){
      return this.fb.group({
        response: [null, [Validators.required]],
        response_match: [null, [Validators.required]],
     });
    }else{
      return this.fb.group({
        response: [null, [Validators.required]],
     });
    }
  }
  initItemResEdit(value:any): FormGroup {
      return this.fb.group({
        response: [value, [Validators.required]],
     });
  }

  clearFormArray = (formArray: FormArray) => {
    while (formArray.length !== 0) {
      formArray.removeAt(0)
    }
  }
  
  /****** chnage question type like MCQ and true false***/
  questionTypes(index: number, event: any, formArray:FormArray) {
    this.clearFormArray(formArray);
    if (event == this.questionTypes_Obj.MCQ) {
      this.optionIndex = index;
      this.adds.push(this.initItemRes({questionTypes: event}));
      this.adds.push(this.initItemRes({questionTypes: event}));
       (<FormArray>(this.questionsGetter).controls[index]).get('correct_response_no')?.setValue(null);
    } else if(event == this.questionTypes_Obj.TF) {
       this.optionIndex = index;
       this.adds.push(this.initItemResEdit('True'));
       this.adds.push(this.initItemResEdit('False'));
      (<FormArray>(this.questionsGetter).controls[index]).get('correct_response_no')?.setValue(null);
    }else{
      this.optionIndex = index;
      this.adds.push(this.initItemRes({questionTypes: event}));
      this.adds.push(this.initItemRes({questionTypes: event}));
      (<FormArray>(this.questionsGetter).controls[index]).get('correct_response_no')?.setValue(null);
      (<FormArray>(this.questionsGetter).controls[index]).get('correct_response_no')?.clearValidators();
      (<FormArray>(this.questionsGetter).controls[index]).get('correct_response_no')?.setValidators(null);
      (<FormArray>(this.questionsGetter).controls[index]).get('correct_response_no')?.updateValueAndValidity();
    }
  }
  /***********create module assessment***********/
  createModuleAss(form: any) {
   
    this.submitted = true;
    this.internalError = 0;
    this.ExternalError = 0;
    let criInternal = this.createAssessmentForm.value.internal_org_pass_no_of_questions;
    let criExternal = this.createAssessmentForm.value.external_org_pass_no_of_questions;
    /*********validation number of question should be gretter than or equal to PASSING CRITERIA */
    if (criInternal != '' && criExternal != '') {
      if (criInternal > criExternal && criInternal > this.questionsGetter.length) {
        this.internalError = 1;
      } else if (criInternal < criExternal && criExternal > this.questionsGetter.length) {
        this.ExternalError = 1;
      } else if (criInternal == criExternal && criExternal > this.questionsGetter.length) {
        this.internalError = 1; this.ExternalError = 1;
      }
    }
   
    // stop here if form is invalid
     if (this.createAssessmentForm.valid && this.internalValidateError == 0 && this.externalValidateError == 0 && this.minError == '1' &&
         this.internalError == 0 && this.ExternalError == 0) {
      let formValue = this.createAssessmentForm.value;
      this.spinner.show();
      
      let qts = formValue.questions;
      for (let n = 0; n < qts.length; n++) {
        qts[n]['question_num'] = n + 1;
      }
      formValue['questions'] = qts;
      if (this.assData != null && this.assData != '') {
        this.page = 'edit';
        formValue['assessment_id'] = this.assData;
        formValue['is_active'] = 1;
      } else {
        this.page = 'create';
      }
      this.auth.createassessment(formValue, this.page).subscribe(
        data => {

          if (data.status == 201 || data.status == 200) {
            this.assessmentId = data.assessment_id;
            this.returnObj.assessment_id = data.assessment_id;
            this.returnObj.status = true;
            this.finalSubmit.emit(this.returnObj);
            this.spinner.hide();
          } else {
            this.spinner.hide();
          }
        }, error => {
          this.spinner.hide();
        }
      );
     } else {
       this.spinner.hide();
      for (const i in this.createAssessmentForm.controls) {
        if (this.createAssessmentForm.controls.hasOwnProperty(i)) {
          this.createAssessmentForm.controls[i].markAsDirty();
          this.scrollToFirstInvalidControl();
          this.createAssessmentForm.controls[i].updateValueAndValidity();
        }
      }
      for (const i in (this.questionsGetter).controls) {
        if ((this.questionsGetter).controls.hasOwnProperty(i)) {
          for (const j in (<FormArray>(this.questionsGetter).controls[i]).controls) {
            if ((<FormArray>(this.questionsGetter).controls[i]).controls.hasOwnProperty(j)) {
              (<FormArray>(this.questionsGetter).controls[i]).controls[j].markAsDirty();
              this.scrollToFirstInvalidControl();
              (<FormArray>(this.questionsGetter).controls[i]).controls[j].updateValueAndValidity();
              for (const k in (<FormArray>(<FormArray>(this.questionsGetter).controls[i]).controls[j]).controls) {
                if ((<FormArray>(<FormArray>(this.questionsGetter).controls[i]).controls[j]).controls.hasOwnProperty(k)) {
                  for (const l in (<FormArray>(<FormArray>(<FormArray>(this.questionsGetter).controls[i]).controls[j]).controls[k]).controls) {
                    if ((<FormArray>(<FormArray>(<FormArray>(this.questionsGetter).controls[i]).controls[j]).controls[k]).controls.hasOwnProperty(l)) {
                      (<FormArray>(<FormArray>(<FormArray>(this.questionsGetter).controls[i]).controls[j]).controls[k]).controls[l].markAsDirty();
                      (<FormArray>(<FormArray>(<FormArray>(this.questionsGetter).controls[i]).controls[j]).controls[k]).controls[l].updateValueAndValidity();
                      this.scrollToFirstInvalidControl();
                    }
                  }
                }
              }
            }
          }
        }
      }
     }
  }
  /***********Upload File select *********/
  uploadFileProgress(index: number, event: any) {
    (<FormArray>(this.questionsGetter).controls[index]).get('question_asset_url')?.setValue('');
    (<FormArray>(this.questionsGetter).controls[index]).get('question_asset_type')?.setValue('');
    if (event.target.files.length > 0) {
      this.UploadFileData = event.target.files.item(0)
      var mimeType = this.UploadFileData.type;
      if (mimeType.match(/image\/(png|jpeg|jpg)/) == null) {
        this.errorMsgImgSize = 'Only png , jpeg , jpg file supported only';
        document.getElementById('errorImg')?.click();
        return;
      }
      if (this.UploadFileData.size / 1024 > 5120) {
        this.errorMsgImgSize = 'The maximum supported file sizes are 5 MB for assessment';
        document.getElementById('errorImg')?.click();
        return;
      }
      var reader = new FileReader();
      reader.readAsDataURL(this.UploadFileData);
      reader.onload = (_event) => {

        this.uploadImgesurl = reader.result;
        (<FormArray>(this.questionsGetter).controls[index]).get('question_asset_url')?.setValue(this.uploadImgesurl);
        (<FormArray>(this.questionsGetter).controls[index]).get('question_asset_type')?.setValue(1);
      }
    }
  }
  logout() {
    //localStorage.clear();
    localStorage.removeItem('adminLoginPass');
    localStorage.removeItem('adminData');
    this.router.navigate(['./admin-login']);
  }
  /*******canceland reset  model open for conformation ****/
  open(content: any) {
    this.modalService.open(content, { ariaLabelledBy: 'modal-basic-title', centered: true }).result.then((result) => {
      this.closeResult = `Closed with: ${result}`;
    }, (reason) => {
      this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
    });
  }
  private getDismissReason(reason: any): string {
    this.activeCanMod = true;
    this.activeResteMod = true;
    if (reason === ModalDismissReasons.ESC) {
      return 'by pressing ESC';
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return 'by clicking on a backdrop';
    } else {
      return `with: ${reason}`;
    }
  }
  /*******clear assessment form **/
  resetAssForm() {
    document.getElementById('CloseIds')?.click();
    this.createAssessmentForm.value.questions[0].question_type =['1'];

    this.activeResteMod = false;
  }
  /***back page **/
  onBackToAuthCr() {
    document.getElementById('CloseIds')?.click();
    //this.activeCanMod = false;
    this.finalSubmit.emit(this.returnObj);
  }
  drop(event: CdkDragDrop<string[]>) {
    const from = event.previousIndex;
    const to = event.currentIndex;
    this.moveItemInFormArray(this.questionsGetter, from, to);
  }
  /**
  * Moves an item in a FormArray to another position.
  * @param formArray FormArray instance in which to move the item.
  * @param fromIndex Starting index of the item.
  * @param toIndex Index to which he item should be moved.
  */
  moveItemInFormArray(formArray: FormArray, fromIndex: number, toIndex: number): void {
    const from = this.clamp(fromIndex, formArray.length - 1);
    const to = this.clamp(toIndex, formArray.length - 1);
  
    if (from === to) {
      return;
    }
    const previous = formArray.at(from);
    const current = formArray.at(to);
    formArray.setControl(to, previous);
    formArray.setControl(from, current);
  }

  /** Clamps a number between zero and a maximum. */
  clamp(value: number, max: number): number {
    return Math.max(0, Math.min(max, value));
  }

  loadAssesmentById(id: number) {
    this.auth.assessmentDetail(id).subscribe(
      data => {
        if (data.data && data.data.questions) {
          let arr: Array<any> = data.data.questions;
          
          arr.forEach((element,i) => {
           
            element.question_type = element.question_type.toString();
            element.correct_response_no = (element.correct_response_no) ? element.correct_response_no.toString() : null;
            this.questionsGetter.push(this.initItemMore({questionTypes: element.question_type}));
            for (let n = 2; n < element.responses.length; n++) {
              if(element.responses[n].response !='' && element.responses[n].response != null){
                this.addNewOptions({index: i,question_type: element.question_type});
              }
            }
          });
        //  this.deleteRow(this.questionsGetter.length - 1);
            this.createAssessmentForm.patchValue(data.data);
        }
      }, error => {
        alert(error);
      }
    );
  }

  ngOnInit(): void {
    this.adminData = JSON.parse(localStorage.getItem('adminData') || '[]');
    this.counterData = this.loadCounter(12);
    this.counterMinuites = this.loadCounter(59);
    if (this.assData != null && this.assData != '') {
      this.createAssessmentForm = this.fb.group({
        assessment_instruction: ['', [Validators.required]],
        assest_time_hr: ['', [Validators.required]],
        assest_time_min: [''],
        assessment_type: ['1'],
        is_active: ['1'],
        internal_org_pass_no_of_questions: ['', [Validators.required, Validators.pattern("^[0-9]*$")]],
        external_org_pass_no_of_questions: ['', [Validators.required, Validators.pattern("^[0-9]*$")]],
        questions: this.fb.array([])
      });
      this.loadAssesmentById(this.assData);
    } else {
      this.createAssessmentForm = this.fb.group({
        assessment_instruction: ['', [Validators.required]],
        assest_time_hr: ['', [Validators.required]],
        assest_time_min: [''],
        assessment_type: ['1'],
        is_active: ['1'],
        internal_org_pass_no_of_questions: ['', [Validators.required, Validators.pattern("^[0-9]*$")]],
        external_org_pass_no_of_questions: ['', [Validators.required, Validators.pattern("^[0-9]*$")]],
        questions: this.fb.array([this.initItemMore({questionTypes: this.questionTypes_Obj.MCQ})])
      });
    }
  }
  private scrollToFirstInvalidControl() {
    const firstInvalidControl: HTMLElement = this.el.nativeElement.querySelector(
      "form .ng-invalid"
    );

    // firstInvalidControl.focus(); //without smooth behavior
    window.scroll({
      top: this.getTopOffset(firstInvalidControl),
      left: 0,
      behavior: "smooth"
    });
  }
  private getTopOffset(controlEl: HTMLElement): number {
    const labelOffset = 50;
    return controlEl.getBoundingClientRect().top + window.scrollY - labelOffset;
  }
  // addMore(i:any){
   
  //   if(this.showTextbox1==false && this.showTextbox2==false){
  //     this.showTextbox1=true;
  //     this.showTextbox2=false
  //   }
  //  else if(this.showTextbox1==true && this.showTextbox2==false){
  //     this.showTextbox1=true;
  //     this.showTextbox2=true
  //   }
  //  else if(this.showTextbox1==true && this.showTextbox2==true){
  //     this.showTextbox1=true;
  //     this.showTextbox2=true
  //   }
  //   else{
  //     this.showTextbox1=false
  //     this.showTextbox2=false

  //   }
  // }
  // deleteText(i:any){
  
  //   this.createAssessmentForm.controls.questions.controls[0].value.response_5.reset()
  //   this.createAssessmentForm.controls.questions.controls[0].value.response_5.reset()
  // //  this.showTextbox1=false;
  // }
  // deleteText1(){
  //   this.createAssessmentForm.get('questions').controls.get('response_6').disabled=true
  //  // this.showTextbox1=false;
  // }
}


